import { render } from "./role.vue?vue&type=template&id=07c9cdcd&scoped=true"
import script from "./role.vue?vue&type=script&lang=js"
export * from "./role.vue?vue&type=script&lang=js"

import "./role.vue?vue&type=style&index=0&id=07c9cdcd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07c9cdcd"

export default script